<template>
  <div class="grid">
    <div class="common-title" id="TEAM-BUILDING">
      <div class="common-title-content">
        智慧微场景数据服务专家
      </div>
    </div>
    <div class="intro-show-panels">
      <div class="panel">
        <div class="icon ico_sys"></div>
        <div class="info">
          <h4>自主研发城市微场景大数据中台</h4>
          <p>
            提供城市级海量数据处理能力，构建城市微场景数据大脑，自研的大数据引擎，以及搭建的城市微场景业务算法模型，能够支撑场景治理的实战应用。
          </p>
        </div>
      </div>
      <div class="panel">
        <div class="icon ico_device"></div>
        <div class="info">
          <h4>宽窄带物联网集群网络</h4>
          <p>
            融合宽带、窄带物联网、5G多网络传输技术，编织便捷数据采集传输网络，打造多场景化最优传输方案。
          </p>
        </div>
      </div>
      <div class="panel">
        <div class="icon ico_aiot"></div>
        <div class="info">
          <h4>AIOT泛在接入能力</h4>
          <p>
            支持多类型物联网感知设备泛在接入，拥有全系列物联网生态链条，提供多维物联网业务场景应用，一站式人工智能物联网解决方案。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dataService"
};
</script>

<style lang="less" scoped>
.grid {
  background-color: #f3f5f7;
  .intro-show-panels {
    padding: 0 11.6rem 6rem;
    display: flex;
    justify-content: space-between;
    .panel {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-basis: 17.5rem;
      .icon {
        background-repeat: no-repeat;
        background-size: 100%;
        &.ico_sys {
          width: 5.9rem;
          height: 6.95rem;
          background-image: url("~@/assets/images/home/ico_sys.png");
        }
        &.ico_device {
          width: 6.5rem;
          height: 6.95rem;
          background-image: url("~@/assets/images/home/ico_device.png");
        }
        &.ico_aiot {
          width: 6.5rem;
          height: 6.95rem;
          background-image: url("~@/assets/images/home/ico_aiot.png");
        }
      }
      h4 {
        margin: 2.9rem 0 0.9rem;
        font-size: 1.1rem;
        color: #333333;
        text-align: center;
      }
      p {
        font-size: 0.8rem;
        color: #5f6464;
        line-height: 1.1rem;
        text-align: justify;
      }
    }
  }
}
</style>
